// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".art-auto-size{background-color:transparent!important}.art-video-player{pointer-events:none;height:100%!important;width:100%!important}.art-video-player,.art-video-player .art-video{background-color:transparent!important}.art-video-player *{z-index:0}.art-video-player>:not(video){display:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
